<section class="section-wrapper homepage-first-section">
  <div class="container first-container">
    <img src="assets/homepage/digital-business-cards/collage.png" class="first-section-collage" alt="collage">
    <div class="row">
      <div class="d-flex align-items-center i-width-100">
        <div class="first-section-left z-index-1">
          <span class="digital-business-card-text"
                [ngClass]="{' digital-business-card-text-am': currentLang === Language.HY, 'digital-business-card-text-ru': currentLang === Language.RU}">{{ 'home-page-content.digital_card' | translate }}</span>
        </div>
        <div class="first-section-middle z-index-1">
          <a class="filled-button tall-button"
             (click)="navigateToSignUp()">{{ 'home-page-content.digital_card_button' | translate }}</a>
        </div>
        <div class="first-section-right z-index-1">
          <span class="connect-transact-with-ease"
                [ngClass]="{'connect-transact-with-ease-am': currentLang === Language.HY}">{{ 'home-page-content.digital_card_title' | translate }}</span>
          <br>
          <span class="connect-transact-with-ease-under"
                [ngClass]="{'connect-transact-with-ease-under-am': currentLang === Language.HY}">{{ 'home-page-content.digital_card_description' | translate }}</span>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="homepage-first-section-mb flex-direction-column">
  <div class="flex-direction-row justify-content-center">
    <span class="digital-business-card-text digital-business-card-text-mb"
          [ngClass]="{'digital-business-card-text-am': currentLang === Language.HY}">{{ 'home-page-content.digital_card' | translate }}</span>
    <img src="assets/homepage/digital-business-cards/vector-mb.svg" id="first-section-vector-mb" alt="">
  </div>
  <div class="d-flex justify-content-center i-width-100"
       [ngClass]="{'d-flex justify-content-center i-width-100 mt-negative-80px': currentLang === Language.HY}">
    <img src="assets/homepage/digital-business-cards/collage-mb.png" class="i-width-100 first-section-collage-mb"
         alt="collage">
  </div>
  <div class="i-width-100">
    <a class="filled-button tall-button mobile-button"
       (click)="navigateToSignUp()">{{ 'home-page-content.digital_card_button' | translate }}</a>
  </div>
  <div class="z-index-1 i-width-100 mt-4">
    <span class="connect-transact-with-ease"
          [ngClass]="{'connect-transact-with-ease-am': currentLang === Language.HY}">{{ 'home-page-content.digital_card_title' | translate }}</span>
    <br>
    <span class="connect-transact-with-ease-under"
          [ngClass]="{'connect-transact-with-ease-under-am': currentLang === Language.HY}">{{ 'home-page-content.digital_card_description' | translate }}</span>
  </div>
</section>
